import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import {
  PROPERTY_BASE_URLS,
  PROPERTY_PROMOTIONS_URL_PATHS
} from 'containers/PromotionLandingPage';
import LoadingIndicator from 'components/LoadingIndicator';
import LocationPreference from 'components/LocationPreference';
import { PROPERTIES } from 'utils/constants';
import { getUserData } from 'utils/graphQLFunctions';
import { CHANGE_PREFERRED_LOCATION_MUTATION } from 'utils/graphql/patronQueries';
import { errorShape, userShape } from 'utils/shapes';

class CalendarPage extends Component {
  constructor(props) {
    super(props);

    this.handleSelectPreferredLocation =
      this.handleSelectPreferredLocation.bind(this);
    this.handlePreferredLocationModal =
      this.handlePreferredLocationModal.bind(this);
    this.handleOnClosePreferredLocation =
      this.handleOnClosePreferredLocation.bind(this);
    this.handleOnCloseCalendarPreferredLocation =
      this.handleOnCloseCalendarPreferredLocation.bind(this);
    this.openPropertyUrl = this.openPropertyUrl.bind(this);

    this.state = {
      showModal: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      // userData,
      location
    } = nextProps;

    // Normally we check to see if the user's preferred location is not set
    // before showing the modal. For now we want to show this at all times, but
    // will be restoring the previous logic at some point, so leaving this
    // unused code here for now.
    //const userPreferredLocation =
    //  userData && userData.user && userData.user.preferredLocation;
    //const preferredLocation =
    //  userPreferredLocation && userPreferredLocation.toLowerCase();

    if (!(location && location.isExiting)) {
      this.handlePreferredLocationModal();
    }
  }

  handleSelectPreferredLocation(location) {
    const { userData } = this.props;

    const newLocation = location.toLowerCase();
    const userPreferredLocation =
      userData && userData.user && userData.user.preferredLocation;

    const propertyUrl = PROPERTY_BASE_URLS[newLocation];
    const propertyBookingPath = PROPERTY_PROMOTIONS_URL_PATHS[newLocation];

    if (location) {
      if (!userPreferredLocation) {
        this.props.changePreferredLocation(location);
      }

      this.openPropertyUrl(`${propertyUrl}${propertyBookingPath}`);
    }
  }

  handleOnCloseCalendarPreferredLocation() {
    const { history } = this.props;
    this.handleOnClosePreferredLocation();
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/');
    }
  }

  handlePreferredLocationModal() {
    this.setState({ showModal: true });
  }

  handleOnClosePreferredLocation() {
    this.setState({ showModal: false });
  }

  openPropertyUrl(propertyUrl) {
    const { propertyUrlOpened } = this.state;

    if (!propertyUrlOpened) {
      this.setState({
        propertyUrlOpened: true
      });

      window.open(propertyUrl);
    }
  }

  renderPreferredLocationModal(userData) {
    const user = userData && userData.user;

    if (userData.loading && !user) {
      return <LoadingIndicator expand />;
    } else if (userData.error || !user) {
      return (
        <div className={'alert alert-danger'}>
          {
            'Failed to retrieve player info. If this continues, please contact support.'
          }
        </div>
      );
    }

    return (
      <LocationPreference
        onSelectPreference={this.handleSelectPreferredLocation}
        selectedPreference={user.preferredLocation}
        currSelectedPreference={user.preferredLocation}
        show={this.state.showModal}
        playAnimation={false}
        backdrop={'static'}
        availableLocations={Object.values(PROPERTIES)}
        onClose={this.handleOnCloseCalendarPreferredLocation}
        title={'Casino Calendars'}
        label={
          'Select the location where you’d like to see events and promotions'
        }
        retainModal={true}
      />
    );
  }

  render() {
    const { userData } = this.props;

    return (
      <React.Fragment>
        {this.renderPreferredLocationModal(userData)}
      </React.Fragment>
    );
  }
}

CalendarPage.propTypes = {
  userData: PropTypes.shape({
    user: userShape,
    loading: PropTypes.bool,
    error: errorShape
  })
};

export default compose(
  getUserData({
    name: 'userData'
  }),
  graphql(CHANGE_PREFERRED_LOCATION_MUTATION, {
    props: ({ mutate }) => ({
      changePreferredLocation: location =>
        mutate({
          variables: { input: { preferredLocation: location } }
        })
    })
  })
)(CalendarPage);
